import { render, staticRenderFns } from "./Manancial.vue?vue&type=template&id=3e74cd24&scoped=true"
import script from "./Manancial.vue?vue&type=script&lang=js"
export * from "./Manancial.vue?vue&type=script&lang=js"
import style0 from "./Manancial.vue?vue&type=style&index=0&id=3e74cd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e74cd24",
  null
  
)

export default component.exports